(function () {
  "use strict";

  var root = document.querySelector("[data-tapgo-bundle]");
  if (!root) return;

  var cartRoot =
    (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
  var productAvailable = root.dataset.productAvailable !== "false";

  var options = root.querySelectorAll("[data-dsb-option]");
  var totalEl = root.querySelector("[data-dsb-total]");
  var compareEl = root.querySelector("[data-dsb-compare]");
  var addBtn = root.querySelector("[data-dsb-add]");
  var addLabel = root.querySelector("[data-dsb-add-label]");
  var adding = false;

  function getSelected() {
    return root.querySelector("[data-dsb-option].is-selected");
  }

  function optionAvailable(sel) {
    if (!sel) return false;
    if (sel.dataset.available === "false") return false;
    return !!parseInt(sel.dataset.variantId, 10);
  }

  function updateUI() {
    var sel = getSelected();
    if (!sel) return;
    var totalLabel = sel.dataset.totalLabel || "";
    var compareLabel = sel.dataset.compareLabel || "";

    if (totalEl) totalEl.textContent = totalLabel;
    if (compareEl) {
      if (compareLabel) {
        compareEl.textContent = compareLabel;
        compareEl.hidden = false;
      } else {
        compareEl.textContent = "";
        compareEl.hidden = true;
      }
    }

    var ok = productAvailable && optionAvailable(sel);
    if (addBtn) addBtn.disabled = !ok || adding;
    if (addLabel) {
      if (!ok) {
        addLabel.textContent = "Sin stock momentáneo";
      } else {
        addLabel.textContent = "Agregar al carrito";
      }
    }
  }

  function selectOption(opt) {
    options.forEach(function (el) {
      var on = el === opt;
      el.classList.toggle("is-selected", on);
      el.setAttribute("aria-pressed", on ? "true" : "false");
    });
    updateUI();
  }

  options.forEach(function (opt) {
    opt.addEventListener("click", function () {
      selectOption(opt);
    });
  });

  function addToCart() {
    if (!addBtn || addBtn.disabled || adding) return;
    var sel = getSelected();
    if (!sel || !optionAvailable(sel)) return;

    var variantId = parseInt(sel.dataset.variantId, 10);
    var qty = parseInt(sel.dataset.qty, 10) || 1;
    var pack = sel.dataset.pack || "unidad";
    var packLabel = sel.dataset.packLabel || "1 Unidad";
    var packTotal = sel.dataset.total || "";
    var packCompare = sel.dataset.compareLabel || "";
    var shipUnits = sel.dataset.shipUnits || "1";

    adding = true;
    addBtn.disabled = true;
    if (addLabel) addLabel.textContent = "Agregando…";

    fetch(cartRoot + "cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({
        items: [
          {
            id: variantId,
            quantity: qty,
            properties: {
              _tapgo_bundle: "1",
              _tapgo_pack: pack,
              _tapgo_pack_size: "1",
              _tapgo_pack_label: packLabel,
              _tapgo_pack_total: String(packTotal),
              _tapgo_pack_compare: String(packCompare.replace(/[^\d]/g, "") || "0"),
              _tapgo_ship_units: String(shipUnits),
            },
          },
        ],
      }),
    })
      .then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok) {
            var err = new Error(
              (data && (data.description || data.message)) ||
                "No pudimos agregar al carrito.",
            );
            err.data = data;
            throw err;
          }
          return data;
        });
      })
      .then(function () {
        adding = false;
        updateUI();
        if (window.TapGOCart && typeof window.TapGOCart.refresh === "function") {
          window.TapGOCart.refresh().then(function () {
            window.TapGOCart.open();
          });
        } else {
          document.dispatchEvent(new CustomEvent("tapgo:cart-updated"));
        }
      })
      .catch(function (err) {
        adding = false;
        updateUI();
        window.alert(
          (err && err.message) ||
            "No pudimos agregar al carrito. Probá de nuevo.",
        );
      });
  }

  if (addBtn) {
    addBtn.addEventListener("click", addToCart);
  }

  document.querySelectorAll("[data-dsb-scroll]").forEach(function (el) {
    el.addEventListener("click", function (e) {
      e.preventDefault();
      root.scrollIntoView({ behavior: "smooth", block: "start" });
    });
  });

  if (window.location.hash === "#tapgo-bundle" || window.location.hash === "#comprar") {
    setTimeout(function () {
      root.scrollIntoView({ behavior: "smooth", block: "start" });
    }, 100);
  }

  updateUI();
})();
